<template>
  <v-select
      dense
      rounded
      filled
      v-model="groupField"
      :items="items"
      prepend-inner-icon="mdi-order-bool-descending"
      :label="$t('label')"
      single-line
      hide-details
  ></v-select>
</template>

<script>
export default {
  name: 'PageGroup',
  props: ['group'],
  data () {
    return {
      groupField: this.group,
      items: [
        {
          text: this.$t('group-by-website'),
          value: 'domain'
        },
        {
          text: this.$t('group-by-tags'),
          value: 'tags'
        },
        {
          text: this.$t('group-by-geolang'),
          value: 'geolang'
        },
      ]
    }
  },
  watch: {
    group (value) {
      this.groupField = value
    },
    groupField () {
      this.$emit('changed', this.groupField)
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"group-by-geolang": "Group by Country/Language",
		"group-by-tags": "Group by tags",
		"group-by-website": "Group by website",
		"label": "Group..."
	},
	"es": {
		"group-by-geolang": "Agrupar por país/idioma",
		"group-by-tags": "Agrupar por etiquetas",
		"group-by-website": "Agrupar por sitio web",
		"label": "Grupo..."
	},
	"fr": {
		"group-by-geolang": "Grouper par Pays/Langue",
		"group-by-tags": "Grouper par tags",
		"group-by-website": "Grouper par site web",
		"label": "Grouper ..."
	},
	"it": {
		"group-by-geolang": "Raggruppa per Paese/Lingua",
		"group-by-tags": "Raggruppa per tag",
		"group-by-website": "Raggruppa per sito web",
		"label": "Raggruppa..."
	},
	"pt": {
		"group-by-geolang": "Agrupar por País/Idioma",
		"group-by-tags": "Agrupar por tags",
		"group-by-website": "Agrupar por site",
		"label": "Agrupar..."
	},
	"pl": {
		"group-by-geolang": "Grupuj według Kraju/Języka",
		"group-by-tags": "Grupuj według tagów",
		"group-by-website": "Grupuj według strony",
		"label": "Grupuj..."
	}
}
</i18n>